// Global configuration constants
    export const APP_CONFIG = {
      name: 'MindGarden',
      version: '2.1.0', // Version bump for prestige system
      storage: {
        gameState: 'mindgarden-game-v4', // Version bump for new state
        userAuth: 'mindgarden-user',
        onboarding: 'mindgarden-onboarding',
        analytics: 'mindgarden-analytics-v1',
        kanban: 'mindgarden-kanban-v1',
        habits: 'mindgarden-habits-v1',
        thoughts: 'mindgarden-thoughts-v1',
        weeds: 'mindgarden-weeds-v1',
        trainingCards: 'mindgarden-training-cards-v1',
        calendar: 'mindgarden-calendar-v1',
      },
      routes: {
        fullWidth: [],
      },
    };
    
    export const GAME_CONFIG = {
      autoSaveInterval: 2000,
      tickInterval: 100,
      focusLengths: [15, 25, 45, 60],
      dailyRewards: [50, 75, 100, 150, 200, 300, 500],
      production: {
        planterRate: 1.0,
        gardenerRate: 1.5,
        planterBaseCost: 25,
        gardenerBaseCost: 150,
        costMultiplier: 1.15,
      },
      upgrades: {
        efficiencyBase: 100,
        automationBase: 250,
        upgradeMultiplier: 1.35,
      },
      prestige: {
        compostBonus: 0.25, // Renamed from multiplierIncrement
        maxMultiplier: 10.0, // Added cap for game balance
        prestigeBaseRequirement: 1000000,
        prestigeCostMultiplier: 5,
      },
      mentors: {
        butler: { dailySeeds: 6, spsGrant: 50 },
        rhino: { dailySeeds: 5, spsGrant: 1000 },
        panda: { dailySeeds: 7, spsGrant: 1250 },
        leo: { dailySeeds: 10, spsGrant: 2000 },
        octomind: { dailySeeds: 8, spsGrant: 3000 },
        xillian: { dailySeeds: 15, spsGrant: 5000 },
      },
      sps: {
        dailyBonusDivisor: 200,
      },
    };
    
    export const THEME_COLORS = {
      sage: '#9BB898',
      beige: '#F5F0E8',
      charcoal: '#2C2C2C',
      goldenrod: '#E2A93B',
      lavender: '#B79AD0',
      crimson: '#D14D4D',
      skyblue: '#6DAEDB',
      moss: '#7AA378',
      jade: '#2F6B4B',
    };